import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const productGroupAPI = createApi({
    reducerPath: "productGroupAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllProductGroups: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/product-group?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["product_groups"],
        }),
        getSpecificProductGroupDetails: builder.mutation({
            query: ({ id }) => {
                let apiUrl = `admin/product-group/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        createProductGroup: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/product-group",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["product_groups"],
        }),
        updateProductGroup: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/product-group`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["product_groups"],
        }),
        deleteProductGroup: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `admin/product-group/${id}`,
                    method: "DELETE"
                };
            },
            invalidatesTags: ["product_groups"],
        }),

        updateProductGroupPrice: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/product-group/price`,
                    method: "PUT",
                    body: data
                };
            }
        }),
        updateProductGroupDiscount: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/product-group/discount`,
                    method: "PUT",
                    body: data
                };
            }
        })
    })
});

export const { 
    useGetAllProductGroupsMutation,
    useGetSpecificProductGroupDetailsMutation,
    useCreateProductGroupMutation,
    useUpdateProductGroupMutation,
    useDeleteProductGroupMutation,

    useUpdateProductGroupPriceMutation,
    useUpdateProductGroupDiscountMutation
} = productGroupAPI;

export default productGroupAPI;